<template>
  <div>
    <section class="hero">
      <div class="container">
        <div class="hero-content">
          <h1>{{ $t('hero_company') }}</h1>
          <p>{{ $t('hero_description') }} </p>
          <!--          <div class="hero-buttons">-->
          <!--            <el-button type="primary" size="medium"> {{ $t('hero_button') }}</el-button>-->
          <!--          </div>-->
        </div>
      </div>
    </section>

    <!-- 公司介绍 -->
    <section class="team">
      <div class="container">
        <div class="section-title">
          <h2>{{ $t('profile_title') }} </h2>
          <p>{{ $t('profile_deputy_title') }} </p>
        </div>
        <div class="profile-content">
          <div class="profile-text">
            <h3>{{ $t('profile_content_title') }} </h3>
            <p> {{ $t('profile_content_1') }} </p>
            <p> {{ $t('profile_content_2') }} </p>
            <p> {{ $t('profile_content_3') }} </p>
          </div>
          <div class="profile-video">
            <video-player ref="videoPlayer_1" class="vjs-custom-skin" :options="playerOptions_1"></video-player>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="profile-content">
          <div class="profile-video">
            <video-player ref="videoPlayer_2" class="vjs-custom-skin" :options="playerOptions_2"></video-player>
          </div>
          <div class="profile-text">
            <h3>{{ $t('profile_content_title') }} </h3>
            <p> {{ $t('profile_content_1') }} </p>
            <p> {{ $t('profile_content_2') }} </p>
            <p> {{ $t('profile_content_3') }} </p>
          </div>
        </div>
      </div>

    </section>

    <!-- 团队介绍 -->
    <section class="team">
      <div class="container">
        <div class="section-title">
          <h2>{{ $t('reason_title') }}</h2>
          <p>{{ $t('team_deputy_title') }}</p>
        </div>
        <div class="team-grid">
          <div class="team-member" v-for="member in $t('teamMembers')" :key="member.id">
            <div class="member-avatar">
              <img :src="member.avatar" :alt="member.name">
            </div>
            <h3>{{ member.name }}</h3>
            <div class="position">{{ member.position }}</div>
            <p>{{ member.description }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 数据统计区域 -->
    <section class="data-stats">
      <div class="container">
        <div class="section-title">
          <h2>{{ $t('data_title') }}</h2>
          <p>{{ $t('data_deputy_title') }}</p>
        </div>
        <div class="stats-grid">
          <div class="stat-card" v-for="stat in $t('dataStats')" :key="stat.id">
            <div class="stat-icon">
              <i :class="stat.icon"></i>
            </div>
            <div class="stat-number">{{ stat.value }}</div>
            <div class="stat-label">{{ stat.label }}</div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>
<script>

export default {
  name: `HomeView`,
  data() {
    return {
      //  options
      playerOptions_1: {
        // 播放地址，可以是本地路径
        sources: [{
          type: "video/mp4",
          src: require('@/assets/3d_1.mp4') // 使用webpack的require来引入本地视频文件
        }],
        autoplay: true, // 如果为true,浏览器准备好时开始回放。
        muted: true, // 默认情况下将会消除任何音频。
        loop: true, // 是否视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        // aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        playbackRates: [],// 可选的播放速度
        fluid: true,// 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controls: false, // 是否显示控制栏
        // controlBar: {
        //   playToggle: false, // 是否显示播放/暂停按钮
        //   volumePanel: false, // 是否显示音量控制按钮
        //   progressControl: false, // 是否显示进度条控制按钮（拖动）
        //   timeDivider: false, // 是否显示时间分割线（当前时间和总时间）
        //   durationDisplay: false, // 是否显示总时间
        //   remainingTimeDisplay: false, // 是否显示剩余时间，默认为false，因为默认是显示总时间（与上面的冲突）
        //   fullscreenToggle: false  // 是否显示全屏切换按钮
        // }
      },
      //  options
      playerOptions_2: {
        // 播放地址，可以是本地路径
        sources: [{
          type: "video/mp4",
          src: require('@/assets/3d_2.mp4') // 使用webpack的require来引入本地视频文件
        }],
        autoplay: true, // 如果为true,浏览器准备好时开始回放。
        muted: true, // 默认情况下将会消除任何音频。
        loop: true, // 是否视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        // aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        playbackRates: [],// 可选的播放速度
        fluid: true,// 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controls: false, // 是否显示控制栏
      }
    };
  },
  mounted() {
    this.$refs.videoPlayer_1.player.ready(() => {
      try {
        this.$refs.videoPlayer_1.player.play();
      } catch (e) {
        console.error('Error attempting to play', e);
      }
    });

    this.$refs.videoPlayer_2.player.ready(() => {
      try {
        this.$refs.videoPlayer_2.player.play();
      } catch (e) {
        console.error('Error attempting to play', e);
      }
    });
  },
  methods: {}
}
</script>
<style scoped>

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 英雄区域样式 */
.hero {
  background: linear-gradient(135deg, #2c3e50 0%, #1a2530 100%);
  color: white;
  padding: 150px 0 100px;
  text-align: center;
  position: relative;
  overflow: hidden;
  height: 400px;
  margin-top: 98px;
}

.hero:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url('@/assets/photo_3.avif') center/cover no-repeat;
  opacity: 0.4;
}

.hero-content {
  position: relative;
  z-index: 1;
  max-width: 1000px;
  margin: 0 auto;
}

.hero h1 {
  font-size: 3.5rem;
  margin-bottom: 20px;
  font-weight: 700;
}

.hero p {
  font-size: 1.3rem;
  margin: 0 auto 40px;
  opacity: 0.9;
  max-width: 700px;
}

.hero-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
}

/* 视频部分
.hero-stats {
  display: flex;
  justify-content: center;
  gap: 50px;
  margin-top: 60px;
  flex-wrap: wrap;
}

.hero-stat {
  text-align: center;
}

.hero-stat-number {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 5px;
}

.hero-stat-label {
  font-size: 1rem;
  opacity: 0.8;
}
*/

/* 视频部分 */
.profile-content {
  display: flex;
  align-items: center;
  gap: 60px;
}

.profile-text {
  flex: 1;
}

.profile-text h3 {
  font-size: 32px;
  margin-bottom: 25px;
  color: black;
}

.profile-text p {
  margin-bottom: 12px;
  font-size: 19px;
  color: black;
}

.profile-video {
  flex: 1;
  margin-left: 80px;
}

/* 数据统计区域 */
.data-stats {
  padding: 100px 0;
  background: white;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
}

.stat-card {
  text-align: center;
  background-color: white;
  border-radius: 10px;
  padding: 30px 20px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s;
}

.stat-card:hover {
  transform: translateY(-5px);
  background-color: rgba(255, 255, 255, 0.15);
}

.stat-icon {
  font-size: 2.5rem;
  margin-bottom: 15px;
  color: #1a73e8;
}

.stat-number {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 10px;
  color: #2c3e50;
}

.stat-label {
  font-size: 1rem;
  opacity: 0.8;
  color: #909399;
}

/* 团队介绍 */
.team {
  padding: 100px 0 0 0;
  background-color: white;
}

.team-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 30px;
}

.team-member {
  text-align: center;
  background-color: white;
  border-radius: 10px;
  padding: 30px 20px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s;
}

.team-member:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.member-avatar {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto 20px;
  border: 5px solid #f0f0f0;
}

.member-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.team-member h3 {
  font-size: 1.3rem;
  margin-bottom: 5px;
  color: #2c3e50;
}

.team-member .position {
  color: #1a73e8;
  margin-bottom: 10px;
  font-weight: 500;
}

.team-member p {
  color: #909399;
  font-size: 0.9rem;
  margin-bottom: 15px;
}

.member-social a {
  width: 35px;
  height: 35px;
  background-color: #f5f7fa;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  text-decoration: none;
  transition: all 0.3s;
}

.member-social a:hover {
  background-color: #1a73e8;
  color: white;
}

.section-title {
  text-align: center;
  margin-bottom: 60px;
}

.section-title h2 {
  font-size: 2.5rem;
  color: #2c3e50;
  margin-bottom: 15px;
}

.section-title p {
  color: #909399;
  max-width: 700px;
  margin: 0 auto;
}

</style>